<div mat-dialog-content>

    <div class="flex flex-col flex-auto min-w-0">
        <div class="bg-card">
            <div class="flex flex-col min-w-0 ml-4">
                <ng-container *transloco="let t">
                </ng-container>
            </div>
            <br>
            <mat-card-content>
                <h5>Datos generales</h5>
                <form [formGroup]="formObservations" class="row d-flex justify-content-start align-items-center">
                    <div class="col-sm-12 col-md-12 col-xl-12 ">
                        <mat-label>Nombre: <span class="mandatory">*</span></mat-label>
                        <mat-form-field class="custom-field" appearance="outline">
                            <input matInput placeholder="Nombre" formControlName="nombre"
                                oninput="this.value = this.value.toUpperCase()" maxlength="250">
                            <mat-error *ngIf="formObservations.get('nombre').hasError ('required')"><strong>*Este
                                    campo es obligatorio</strong></mat-error>
                        </mat-form-field>
                    </div>
    
                    <div class="col-sm-12 col-md-12 col-xl-12">
                        <mat-label>Descripción: <span class="mandatory">*</span></mat-label>
                        <mat-form-field class="custom-field" appearance="outline">
                            <textarea matInput placeholder="descripción" style="min-height: 150px;" formControlName="observacion" maxlength="1000"
                                oninput="this.value = this.value.toUpperCase()"></textarea>
                            <mat-error *ngIf="formObservations.get('observacion').hasError ('required')"><strong>*Este campo es
                                    obligatorio</strong></mat-error>
                        </mat-form-field>
                    </div>
                </form>

            </mat-card-content>

        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="close(0)">Cerrar</button>
    <button *ngIf="!modificarDatos" mat-flat-button color="accent" [disabled]="!formObservations.valid" (click)="addObservation();">Guardar</button>
    <button *ngIf="modificarDatos" mat-flat-button color="accent" [disabled]="!formObservations.valid" (click)="modifyObservation();">Actualizar</button>
</div>